if (document.body.classList.contains("template-collection")) {
  const params = new URLSearchParams(window.location.search);
  if (!params.has("filter.v.availability")) {
    const url = new URL(window.location.href);
    url.searchParams.set("filter.v.availability", "1");
    window.location.replace(url.toString());
  }
}